import React from 'react';
import 'whatwg-fetch';
import 'intersection-observer';
import { Provider } from 'react-redux';
import './semantic_custom.less';
import { buildStore } from './config/store';
import Application from './components/application';

const store = buildStore();

const WallBuilder = () => (
  <Provider store={ store }>
    <Application />
  </Provider>
);

export default WallBuilder;
